const getContentPublishDate = content =>
  content.publishDate?.timestamp || content.created || 0;

module.exports = { getContentPublishDate };
